import * as tslib_1 from "tslib";
import * as helper from '../../../helper';
import showDiv, { closeAll } from '@ivy/fts/showDiv';
import showApp from '../../../components/showApp.vue';
import { Component, Vue, Prop } from 'vue-property-decorator';
let AlbumAudios = class AlbumAudios extends Vue {
    constructor() {
        super(...arguments);
        this.open = [];
    }
    async mounted() {
        await this.$nextTick();
        if (this.album.show_type === 'group') {
            this.album.groups.map(e => {
                this.open = [...this.open, false];
            });
        }
        this.togglePanel(0);
    }
    get albumCount() {
        if (this.album.show_type === 'group') {
            return this.album.groups.reduce((sum, item) => sum + JSON.parse(item.group_audio_count), 0);
        }
        else {
            return this.album.audio_count;
        }
    }
    async toApp() {
        showDiv(showApp, {
            closeAll
        });
    }
    playAll() {
        let openIndex = helper.countOccurences(this.open, true) > 1 ? 0 : this.open.indexOf(true);
        return helper.toItem({
            data: this.album.show_type === 'group' ? this.album.groups[openIndex].list[0] : this.album.audios[0],
            type: 'audio',
            index: 0,
            from: 'playAllEveryday',
            albumId: this.album.show_type === 'group' ? this.album.groups[openIndex].id : this.album.id
        });
    }
    togglePanel(index = 0) {
        this.$set(this.open, index, !this.open[index]);
    }
};
tslib_1.__decorate([
    Prop()
], AlbumAudios.prototype, "album", void 0);
AlbumAudios = tslib_1.__decorate([
    Component
], AlbumAudios);
export default AlbumAudios;
